/**
 * Detached canvas 2D context, reused across callers for label measurement.
 * Lazy singleton, SSR-safe. `undefined` = uninitialized, `null` = unavailable
 * (cached so we don't retry every call).
 *
 * Callers must set `ctx.font` before measuring.
 */
let measureCtx: CanvasRenderingContext2D | null | undefined;

const createMeasureCtx = (): CanvasRenderingContext2D | null =>
  typeof document === 'undefined' ? null : document.createElement('canvas').getContext('2d');

export const getMeasureCtx = (): CanvasRenderingContext2D | null => {
  if (measureCtx === undefined) {
    measureCtx = createMeasureCtx();
  }

  // Recreate if the cached context's `measureText` is stale — Jest's
  // `resetMocks: true` zeros out `jest-canvas-mock` between tests. No-op in
  // production.
  if (measureCtx !== null && measureCtx.measureText('')?.width === undefined) {
    measureCtx = createMeasureCtx();
  }

  return measureCtx;
};
